export default "__VITE_ASSET__f2f21f80__"